(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-announcements"] && !Shopify.designMode) return;
  try {
    

// ===== 关闭记忆（初始化）=====
const promoBar = document.getElementById('promo-bar');
// const STORAGE_KEY = 'promo_bar_closed';

// if (localStorage.getItem(STORAGE_KEY)) {
//   promoBar.style.display = 'none';
// }

// ===== Copy Code =====
document.querySelectorAll('.promo-code').forEach(el => {
  el.addEventListener('click', function () {
    const code = this.dataset.code;

    navigator.clipboard.writeText(code);

    const copyText = this.querySelector('.copy-text');
    copyText.innerText = 'Copied!';

    setTimeout(() => {
      copyText.innerText = 'Copy';
    }, 2000);
  });
});

// ===== Countdown =====
document.querySelectorAll('.countdown').forEach(el => {
  const endTime = new Date(el.dataset.time).getTime();
  const display = el.querySelector('.time');

  function update() {
    const now = new Date().getTime();
    const diff = endTime - now;

    if (diff <= 0) {
      display.innerText = "Expired";
      return;
    }

    const d = Math.floor(diff / (1000*60*60*24));
    const h = Math.floor((diff / (1000*60*60)) % 24);
    const m = Math.floor((diff / (1000*60)) % 60);
    const s = Math.floor((diff / 1000) % 60);

    const pad = n => n.toString().padStart(2, '0');

    display.innerText = `${pad(d)}d : ${pad(h)}h : ${pad(m)}m : ${pad(s)}s`;
  }

  update();
  setInterval(update, 1000);
});

// ===== Close + 记忆 =====
// document.querySelector('.promo-close')?.addEventListener('click', function () {
//   promoBar.style.display = 'none';

//   // 保存关闭状态
//   //   localStorage.setItem(STORAGE_KEY, 'true');

// });

document.querySelector('.promo-close')?.addEventListener('click', function () {
  const promoBar = document.getElementById('promo-bar');

  // 隐藏 promo bar
  promoBar.style.display = 'none';

  // 给 header 添加类名
  const header = document.getElementById('header-component');
  if (header) {
    header.classList.add('header-active');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured_content_text').forEach(item => { 
      item.addEventListener('click', function (e) { 
          if (e.target.closest('a, button')) return; this.classList.toggle('active-btn'); 
      }); 
  });

(function () {

  if (window.__VIDEO_BANNER_INIT__) return;
  window.__VIDEO_BANNER_INIT__ = true;

  const banners = document.querySelectorAll('.video-banner');
  if (!banners.length) return;

  let currentPlaying = null;

  // 获取当前设备视频
  function getActiveVideo(banner) {
    const pc = banner.querySelector('.video.pc');
    const mobile = banner.querySelector('.video.mobile');
    return window.matchMedia('(max-width: 1023px)').matches ? mobile : pc;
  }

  // 暂停所有
  function pauseAll() {
    banners.forEach(b => {
      const videos = b.querySelectorAll('video');
      videos.forEach(v => v.pause());
      b.classList.remove('playing');
    });
    currentPlaying = null;
  }

  // 播放指定 banner
  function playBanner(banner) {
    const video = getActiveVideo(banner);
    if (!video) return;

    if (currentPlaying && currentPlaying !== banner) {
      pauseAll();
    }

    video.muted = true; // 自动播放必须静音
    video.play().catch(() => {});

    banner.classList.add('playing');
    currentPlaying = banner;
  }

  // 初始化每个 banner
  function initBanner(banner) {
    if (banner.dataset.init) return;
    banner.dataset.init = "true";

    const btn = banner.querySelector('.play-btn');

    // 点击播放按钮
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        const video = getActiveVideo(banner);
        if (!video) return;

        if (!video.paused) {
          video.pause();
          banner.classList.remove('playing');
          currentPlaying = null;
        } else {
          playBanner(banner);
        }
      });
    }

    // 点击视频暂停
    banner.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', function () {
        video.pause();
        banner.classList.remove('playing');
        currentPlaying = null;
      });
    });
  }

  // 初始化全部
  banners.forEach(initBanner);

  // ===== 滚动自动播放（核心）=====
  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {
      const banner = entry.target;

      if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
        // 进入视口 → 播放
        playBanner(banner);
      } else {
        // 离开视口 → 暂停
        const video = getActiveVideo(banner);
        if (video) {
          video.pause();
          banner.classList.remove('playing');
          if (currentPlaying === banner) {
            currentPlaying = null;
          }
        }
      }
    });

  }, {
    threshold: [0.6] // 60%可见才触发
  });

  banners.forEach(b => observer.observe(b));

  // Shopify 编辑器兼容
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('.video-banner').forEach(initBanner);
  });

})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-dual-banner"] && !Shopify.designMode) return;
  try {
    
(function () {

  if (window.__PROMO_PRO_INIT__) return;
  window.__PROMO_PRO_INIT__ = true;

  function initSection(section) {
    if (section.dataset.init) return;
    section.dataset.init = "true";

    const toast = section.querySelector('.toast');

    section.addEventListener('click', function(e){

      const btn = e.target.closest('.code-btn');
      if (!btn) return;

      const code = btn.dataset.code;

      navigator.clipboard.writeText(code);

      /* toast */
      if (toast) {
        toast.classList.add('show');
        setTimeout(()=> toast.classList.remove('show'), 1500);
      }

      /* 鎸夐挳鐘舵€�*/
      const original = btn.innerText;
      btn.innerText = "Copied!";
      btn.disabled = true;

      setTimeout(()=>{
        btn.innerText = original;
        btn.disabled = false;
      },1500);

      /* 鍙€夛細鑷姩璺宠浆 */
      // window.location.href = `/discount/${code}?redirect=/cart`;

    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('.promo-pro').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initAll();
  });

  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winter-promo-dual-banner"] && !Shopify.designMode) return;
  try {
    
(function () {

  if (window.__PROMO_PRO_INIT__) return;
  window.__PROMO_PRO_INIT__ = true;

  function initSection(section) {
    if (section.dataset.init) return;
    section.dataset.init = "true";

    const toast = section.querySelector('.toast');

    section.addEventListener('click', function(e){

      const btn = e.target.closest('.code-btn');
      if (!btn) return;

      const code = btn.dataset.code;

      navigator.clipboard.writeText(code);

      /* toast */
      if (toast) {
        toast.classList.add('show');
        setTimeout(()=> toast.classList.remove('show'), 1500);
      }

      /* 鎸夐挳鐘舵€�*/
      const original = btn.innerText;
      btn.innerText = "Copied!";
      btn.disabled = true;

      setTimeout(()=>{
        btn.innerText = original;
        btn.disabled = false;
      },1500);

      /* 鍙€夛細鑷姩璺宠浆 */
      // window.location.href = `/discount/${code}?redirect=/cart`;

    });
  }

  function initAll(scope = document) {
    scope.querySelectorAll('.promo-pro').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initAll();
  });

  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
  });

})();

  } catch(e) { console.error(e); }
})();
})();
